import React, { memo, useEffect, useState } from "react";
import { SearchSingleFormModel, SearchSingleFunction, SingleInvoiceInfoModel } from "../../../../../model/searchInvoiceModels";
const MainData: React.FC<{ searchFunction: SearchSingleFunction, formValues: SearchSingleFormModel }> = ({ searchFunction, formValues }) => {
    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    useEffect(() => {
        if (!formValues.taxCode || !formValues.securityCode) return;
        searchFunction(formValues.taxCode, formValues.securityCode)
            .then(setBlobUrl)

    }, [JSON.stringify(formValues)])
    return (
        <iframe
            style={{ minHeight: "400px", width: "100%", aspectRatio: "1 / 1.414" }}
            src={blobUrl ?? undefined}
        ></iframe>
    )
}
export default memo(MainData)